import moment from "moment";
import "moment-timezone";

export const columns = [
  { accessorKey: "serialNumber", header: "Serial #", size: 150 },
  { accessorKey: "vehicleNumber", header: "Vehicle", size: 140 },

  { accessorKey: "vehicleStatus", header: "Status", size: 130 },
  { accessorKey: "vehicleTerminalLocation", header: "Location", size: 150 },
  {
    accessorKey: "vehicleWeight",
    header: "Vehicle Weight",
    sortable: true,
    size: 200,
  },
  {
    accessorKey: "totalWeight",
    header: "Total Weight",
    sortable: true,
    size: 180,
  },
  {
    accessorKey: "vehicleConsignmentType",
    header: "Consignment",
    sortable: true,
    size: 180,
  },
  {
    accessorKey: "weightPerformed",
    header: "Performed",
    sortable: true,
    size: 160,
    accessorFn: function customCell(row: any) {
      return `${
        row.weightPerformed ? moment(row.weightPerformed).format("DD-MM-YYYY hh:mm:ss A") : ""
      }`;
    },
  },

  {
    accessorKey: "refNum",
    header: "Reference #",
    size: 170,
    accessorFn: (row: any) => ` ${row.refNum || " "}`,
  },
  {
    accessorKey: "remarks",
    header: "Remarks",
    size: 150,
    accessorFn: (row: any) => ` ${row.remarks || " "}`,
  },
  {
    accessorKey: "files",
    header: "Files",
    size: 130,
    accessorFn: (row: any) => ` ${row.files || " "}`,
  },
  {
    accessorKey: "actions",
    header: "Actions",
    size: 300,
    accessorFn: (row: any) => ` ${row.actions || " "}`,
  },
];
